var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkidloader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    style: {
      fill: "#000"
    },
    width: 1.4,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "10.7,8 8.7,8 8.7,14.1 12.9,14.1 12.9,13.4 10.8,8  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M6.5,17.6c-0.1-1.2-1.1-2.2-2.4-2.2s-2.3,1-2.4,2.2c0,0,0,0.1,0,0.2c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4 C6.6,17.8,6.6,17.7,6.5,17.6z M4.6,18.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5 c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0.1-0.3,0.4-0.5,0.7-0.5s0.6,0.2,0.7,0.5c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1 C4.8,18,4.7,18.2,4.6,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.9,17.6c-0.1-1.2-1.1-2.2-2.4-2.2s-2.3,1-2.4,2.2c0,0,0,0.1,0,0.2c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4 C14.9,17.8,14.9,17.7,14.9,17.6z M13,18.4c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0,0,0-0.1,0-0.1 c0,0,0,0,0-0.1c0.1-0.3,0.4-0.5,0.7-0.5c0.3,0,0.6,0.2,0.7,0.5c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1C13.2,18,13.1,18.2,13,18.4z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1,14.1v-1.1l-2.9-7.3h-0.7V5.5h-0.2c0-0.4,0-1.8-0.9-1.8S9.6,5.1,9.6,5.5H9.4v0.3H5H3.2v2.2v4H1v5.7h0.4 c0.1-1.4,1.2-2.5,2.6-2.5s2.6,1.1,2.6,2.5h1.4h0.3h1.2c0.1-1.4,1.2-2.5,2.6-2.5s2.6,1.1,2.6,2.5h0.3v-3.5 C15.3,14.1,15.1,14.1,15.1,14.1z M6.5,11.9H5v-4h1.4V11.9z M12.9,14.1H8.7V8h2.1h0.2l2,5.5V14.1z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.6,8.6c-2.4,1.6-3,4.9-1.4,7.3l4.3-2.9L16.6,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.5,13l-4.3,2.9c1.6,2.4,4.9,3,7.3,1.4l0,0c0.3-0.2,0.4-0.4,0.4-0.7c0-0.4,0-0.6-0.2-0.8l-0.9,0.6L19.5,13z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkidloader);
export default __webpack_public_path__ + "static/media/skidloader.56a18de64fd9688f16822224841179e2.svg";
export { ForwardRef as ReactComponent };